import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle, XCircle, Spinner } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling"); // polling | success | failed | timeout
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let active = true;
    const MAX = 10;
    let n = 0;
    const poll = async () => {
      if (!active) return;
      n += 1;
      setAttempts(n);
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (!active) return;
        if (data.payment_status === "paid") { setStatus("success"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("failed"); return; }
        if (n >= MAX) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        if (!active) return;
        if (n >= MAX) { setStatus("failed"); return; }
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { active = false; };
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-20" data-testid="payment-success-page">
      <div className="bg-white border-2 border-black p-10 text-center shadow-hard-red">
        {status === "polling" && (
          <>
            <div className="spinner mx-auto mb-6" />
            <h1 className="font-display font-black text-3xl mb-2">Vérification du paiement...</h1>
            <p className="text-zinc-500">Tentative {attempts}/10. Merci de patienter.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle size={72} weight="duotone" className="text-[#00E676] mx-auto mb-6" />
            <h1 className="font-display font-black text-4xl mb-2" data-testid="payment-success-title">Paiement confirmé</h1>
            <p className="text-zinc-600 mb-6">
              Votre commande est validée. Vous allez recevoir un email de confirmation.
            </p>
            <div className="flex gap-3 justify-center">
              <Link to="/compte" className="btn-primary" data-testid="goto-account-btn">Voir mes commandes</Link>
              <Link to="/" className="btn-secondary" data-testid="goto-home-btn">Continuer</Link>
            </div>
          </>
        )}
        {(status === "failed" || status === "timeout") && (
          <>
            <XCircle size={72} weight="duotone" className="text-[#E60000] mx-auto mb-6" />
            <h1 className="font-display font-black text-4xl mb-2">Paiement non confirmé</h1>
            <p className="text-zinc-600 mb-6">
              {status === "timeout"
                ? "Le délai d'attente a été dépassé. Le paiement peut encore être validé sous quelques minutes."
                : "Votre paiement n'a pas pu être confirmé."}
            </p>
            <Link to="/panier" className="btn-primary">Retour au panier</Link>
          </>
        )}
      </div>
    </div>
  );
}
